import React, { Component } from "react";
import PropTypes from "prop-types";
import { NewsletterForm } from "../containers";
import { multiLanguage, withRedux } from "../hoc";

const mapStateToProps = (state) => {
  return state;
};

const actionToProps = {};

@multiLanguage()
@withRedux(mapStateToProps, actionToProps)
class FooterMenu extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  render() {
    const { t } = this.props;
    return (
      <div className="footer-menu">
        <div className="menu-box">
          <h3>{t("Locations")}</h3>
          <ul>
            <li>
              <a href="http://www.bintan.lagunaproperty.com">{t("Bintan")}</a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/project/phuket/laguna-park">
                {t("Phuket")}
              </a>
            </li>
            <li>
              <a href="http://www.lagunalangco.com/en/">{t("Lăng Cô")}</a>
            </li>
          </ul>
        </div>
        <div className="menu-box">
          <h3>{t("The Santuary Club")}</h3>
          <ul>
            <li>
              <a href="https://lagunaproperty.com/en/sanctuary-club">
                {t("About the Club")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/sanctuary-club#ExclusivePrivileges">
                {t("Exclusive Privileges")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/sanctuary-club#ExchangeProgramme">
                {t("Exchange Programme")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/sanctuary-club#Network">
                {t("The Network")}
              </a>
            </li>
          </ul>
        </div>
        <div className="menu-box">
          <h3>{t("Resales")}</h3>
          <ul>
            <li>
              <a href="https://lagunaproperty.com/en/resale/">
                {t("Properties")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/resale/faq">{t("FAQ")}</a>
            </li>
          </ul>
        </div>
        <div className="menu-box">
          <h3>{t("Rentals")}</h3>
          <ul>
            <li>
              <a href="https://lagunaproperty.com/en/rental">
                {t("Properties")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/rental/faq">{t("FAQ")}</a>
            </li>
          </ul>
        </div>
        <div className="menu-box">
          <h3>{t("News/Promotions")}</h3>
          <ul>
            <li>
              <a href="https://lagunaproperty.com/en/news/">
                {t("News/Promotions")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/construction-progress/">
                {t("Construction Progress")}
              </a>
            </li>
          </ul>
        </div>
        <div className="menu-box">
          <h3>{t("About us")}</h3>
          <ul>
            <li>
              <a href="https://lagunaproperty.com/en/about-us#Mission">
                {t("Our Mission")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/about-us#Developer">
                {t("Developer")}
              </a>
            </li>
            <li>
              <a href="https://lagunaproperty.com/en/about-us#Milestones">
                {t("Milestones")}
              </a>
            </li>
          </ul>
        </div>
        <div className="menu-box the-last-one">
          <h3>{t("Newsletter signup")}</h3>
          <NewsletterForm />
        </div>
      </div>
    );
  }
}

export default FooterMenu;



// WEBPACK FOOTER //
// ./src/components/FooterMenu.js